const urls = [
  {
    url: '/',
    responsive: true,
    title: 'other_v111_m_home',
    description: 'other_v111_home',
    keywords: 'other_v111_cryptotrading',
  },
  {
    url: '/indexSearch',
    title: 'other_v111_SearchCryptocurrency',
    description: 'other_v111_indexSearch',
    keywords: 'other_v111_Search',
  },
  {
    url: '/register',
    responsive: true,
    title: 'other_v111_m_register',
    description: 'other_v111_register',
    keywords: 'other_v111_registerhotcoin',
  },
  {
    url: '/login',
    responsive: true,
    title: 'other_v111_WelcometoLogin',
    description: 'other_v111_login',
    keywords: 'other_v111_loginhotcoin',
    group: 'auth',
  },
  { url: '/bindAccount', title: '', description: '', keywords: '' },
  {
    url: '/appTgPage',
    title: 'other_v111_QuickLoginViaTelegram',
    description: 'other_v111_appTgPage',
    keywords: 'other_v111_tg',
  },
  // { url: '/error', title: '', description: '', keywords: '' },
  { url: '/retrievePassword', title: '', description: '', keywords: '' },
  {
    url: '/app/downLoad',
    responsive: true,
    title: 'other_v111_m_AppDownload',
    description: 'other_v111_appdownLoad',
    keywords: 'other_v111_appdownloadhotcoin',
  },
  {
    url: '/app/downLoad/ioslocal',
    title: 'other_v111_AppDownloadIOS',
    description: 'other_v111_appdownLoadioslocal',
    keywords: 'other_v111_ios',
  },
  {
    url: '/app/iosDownLoad',
    title: 'other_v111_m_AppIOSDownload',
    description: 'other_v111_appiosDownLoad',
    keywords: 'other_v111_iosdownload',
  },
  {
    url: '/app/GoogleAuthenticator',
    title: 'other_v111_m__appGoogleAuthenticator',
    description: 'other_v111_appGoogleAuthenticator',
    keywords: 'other_v111_googeauthenticator',
  },
  { url: '/region', title: '', description: '', keywords: '' },
  { url: '/menu/more', title: '', description: '', keywords: '' },
  {
    url: '/app/downLoad/downloadStep',
    responsive: true,
    title: 'other_v111_m_appdownLoaddownloadStep',
    description: 'other_v111_appdownLoaddownloadStep',
    keywords: 'other_v111_download',
  },
  {
    url: '/app/downLoad/storeRegister',
    responsive: true,
    title: 'other_v111_m_appdownLoadstoreRegister',
    description: 'other_v111_appdownLoadstoreRegister',
    keywords: 'other_v111_appregister',
  },
  {
    url: '/app/downLoad/taobaoBuy',
    responsive: true,
    title: 'other_v111_m_appdownLoadtaobaoBuy',
    description: 'other_v111_appdownLoadtaobaoBuy',
    keywords: 'other_v111_taobao',
  },
  {
    url: '/app/downLoad/androidQuestion',
    responsive: true,
    title: 'other_v111_m_appdownLoadandroidQuestion',
    description: 'other_v111_appdownLoadandroidQuestion',
    keywords: 'other_v111_android',
  },
  {
    url: '/currency/index',
    title: 'other_v111_m_currencyindex',
    description: 'other_v111_currencyindex',
    keywords: 'other_v111_currency',
  },
  {
    url: '/currency/exchange',
    title: 'other_v111_m_currencyexchange',
    description: 'other_v111_currencyexchange',
    keywords: 'other_v111_currency_exchange',
  },
  { url: '/currency/details', title: '', description: '', keywords: '' },
  { url: '/currency/entrustOrder', title: '', description: '', keywords: '' },
  {
    url: '/currency/preferences',
    title: 'other_v111_m_currencypreferences',
    description: 'other_v111_currencypreferences',
    keywords: 'other_v111_currencypreference',
  },
  { url: '/redEnvelopes/index', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/send', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/sharePage', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/openPage', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/listPage', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/record', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/blankPage', title: '', description: '', keywords: '' },
  { url: '/redEnvelopes/selectCoinSearch', title: '', description: '', keywords: '' },
  { url: '/markets', title: 'other_v111_m_markets', description: 'other_v111_markets', keywords: 'other_v111_market_' },
  {
    url: '/markets/move',
    title: 'other_v111_m_marketsmove',
    description: 'other_v111_marketsmove',
    keywords: 'other_v111_markets_',
  },
  {
    url: '/markets/editFavorite',
    title: 'other_v111_m_marketseditFavorite',
    description: 'other_v111_marketseditFavorite',
    keywords: 'other_v111_favorite',
  },
  {
    url: '/markets/region',
    title: 'other_v111_m_marketsregion',
    description: 'other_v111_marketsregion',
    keywords: 'other_v111_region',
  },
  {
    url: '/markets/overviewDetail',
    title: 'other_v111_m_marketsoverviewDetail',
    description: 'other_v111_marketsoverviewDetail',
    keywords: 'other_v111_detail',
  },
  {
    url: '/markets/rankList',
    title: 'other_v111_m_marketsrankList',
    description: 'other_v111_marketsrankList',
    keywords: 'other_v111_rank',
  },
  {
    url: '/markets/topCoinTree',
    title: 'other_v111_m_marketstopCoinTree',
    description: 'other_v111_marketstopCoinTree',
    keywords: 'other_v111_topcointree',
  },
  { url: '/markets/overviewVolume', title: '', description: '', keywords: '' },
  { url: '/markets/futuresOverview', title: '', description: '', keywords: '' },
  {
    url: '/support/index',
    title: 'other_v111_hotcoinhelpcenter',
    description: 'other_v111_supportindex',
    keywords: 'other_v111_tradingcryptocurrency',
    responsive: true,
  },
  {
    url: '/support/nav',
    title: 'other_v111_m_supportnav',
    description: 'other_v111_supportnav',
    keywords: 'other_v111_support',
    responsive: true,
  },
  { url: '/support/search', title: '', description: '', keywords: '', responsive: true },
  {
    url: '/support/article',
    title: 'other_v111_m_supportarticle',
    description: 'other_v111_supportarticle',
    keywords: 'other_v111_article',
    responsive: true,
  },
  {
    url: '/support/announcement',
    title: 'other_v111_m_supportannouncement',
    description: 'other_v111_m_ExcitingNewsHotcoinSupport',
    keywords: 'other_v111_announcement',
    responsive: true,
  },
  { url: '/support/announcement/latest', title: '', description: 'other_v111_supportannouncementlatest', keywords: '' },
  {
    url: '/support/verify/officialChannel',
    title: 'other_v111_m_supportverifyofficialChannel',
    description: 'other_v111_supportverifyofficialChannel',
    keywords: 'other_v111_verify',
  },
  { url: '/personalCenter', title: '', description: '', keywords: '' },
  {
    url: '/personalCenter/setUp',
    title: 'other_v111_m_personalCentersetUp',
    description: 'other_v111_personalCentersetUp',
    keywords: 'other_v111_personalcenter',
  },
  { url: '/personalCenter/setNickName', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindPhoneBefore', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/BindThirdPartyAccount', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindPhone', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindEmailBefore', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindEmail', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindGoogleBefore', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindGoogle', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/antiFishingCode', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/modifyLoginPassword', title: '', description: '', keywords: '' },
  { url: '/personalCenter/accountCenter/bindTradePassword', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/verifiedIndex', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/VerifiedResult', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/PersonVerified', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/PersonVerifiedHighLevel', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/CompanyVerified', title: '', description: '', keywords: '' },
  { url: '/personalCenter/invitation', title: '', description: '', keywords: '' },
  { url: '/personalCenter/invitation/detail', title: '', description: '', keywords: '' },
  { url: '/personalCenter/invitation/info', title: '', description: '', keywords: '' },
  { url: '/personalCenter/invitation/talentList', title: '', description: '', keywords: '' },
  { url: '/personalCenter/setAvatar', title: '', description: '', keywords: '' },
  { url: '/personalCenter/setAvatar/setStandard', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/sumsubPrev', title: '', description: '', keywords: '' },
  { url: '/personalCenter/verified/sumsub', title: '', description: '', keywords: '' },
  { url: '/account', title: '', description: '', keywords: '' },
  { url: '/account/capital/overview', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin', title: '', description: '', keywords: '' },
  { url: '/account/capital/swaps', title: '', description: '', keywords: '' },
  { url: '/account/capital/lever', title: '', description: '', keywords: '' },
  { url: '/account/capital/c2c', title: '', description: '', keywords: '' },
  { url: '/account/capital/wealthManagement', title: '', description: '', keywords: '' },
  { url: '/account/capital/chargeBack', title: '', description: '', keywords: '' },
  { url: '/account/transfer', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/coinDetail', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/coinDetail/CoinDetailTotal', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/coinDetail/DetailLog', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/recharge', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/rechargeAddress', title: '', description: '', keywords: '' },
  { url: '/account/coin/recharge/financeLog', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/withdraw', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/confirmation', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/withdrawSucceed', title: '', description: '', keywords: '' },
  { url: '/account/coin/withdraw/financeLog', title: '', description: '', keywords: '' },
  { url: '/account/coin/withdraw/addAddress', title: '', description: '', keywords: '' },
  { url: '/account/coin/withdraw/addressSetting', title: '', description: '', keywords: '' },
  { url: '/account/coin/withdraw/addressBook', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/profitAnalysis', title: '', description: '', keywords: '' },
  { url: '/account/capital/swaps/profitAnalysis', title: '', description: '', keywords: '' },
  { url: '/account/capital/coin/assetBills', title: '', description: '', keywords: '' },
  { url: '/account/swaps/transfer', title: '', description: '', keywords: '' },
  { url: '/account/coin/transfer', title: '', description: '', keywords: '' },
  { url: '/account/capital/swaps/financeLog', title: '', description: '', keywords: '' },
  { url: '/account/capital/swaps/swapsDetail', title: '', description: '', keywords: '' },
  { url: '/account/capital/swaps/statistics', title: '', description: '', keywords: '' },
  { url: '/account/capital/recharge/selectCoin', title: '', description: '', keywords: '' },
  { url: '/account/capital/withdraw/selectCoin', title: '', description: '', keywords: '' },
  { url: '/account/capital/withdraw/selectCoinSearch', title: '', description: '', keywords: '' },
  { url: '/account/capital/wealthManagement/financeLog', title: '', description: '', keywords: '' },
  { url: '/account/capital/lever/leverDetailCross', title: '', description: '', keywords: '' },
  { url: '/account/capital/lever/leverDetailIsolated', title: '', description: '', keywords: '' },
  { url: '/account/lever/transferCross', title: '', description: '', keywords: '' },
  { url: '/account/lever/transferIsolated', title: '', description: '', keywords: '' },
  { url: '/account/lever/borrowReplyCross', title: '', description: '', keywords: '' },
  { url: '/account/lever/borrowReplyIsolated', title: '', description: '', keywords: '' },
  { url: '/account/lever/LeverRecordIndex', title: '', description: '', keywords: '' },
  { url: '/account/lever/LiquidationOrder', title: '', description: '', keywords: '' },
  { url: '/account/lever/LiquidationOrderDetails', title: '', description: '', keywords: '' },
  { url: '/account/lever/LeverData', title: '', description: '', keywords: '' },
  { url: '/account/c2c/transfer', title: '', description: '', keywords: '' },
  { url: '/account/c2c/c2cFinanceLog', title: '', description: '', keywords: '' },
  { url: '/account/chargeBack/financeLog', title: '', description: '', keywords: '' },
  { url: '/account/chargeBack/transfer', title: '', description: '', keywords: '' },
  { url: '/account/chargeBack/transferLog', title: '', description: '', keywords: '' },
  { url: '/account/totalTransfer', title: '', description: '', keywords: '' },
  {
    url: '/swaps/index',
    title: 'other_v111_m_swapsindex',
    description: 'other_v111_swapsindex',
    keywords: 'other_v111_swaps_index',
  },
  {
    url: '/swaps/exchange',
    title: 'other_v111_m_swapsexchange',
    description: 'other_v111_swapsexchange',
    keywords: 'other_v111_swaps_exchange',
  },
  {
    url: '/swaps/entrustDetails',
    title: 'other_v111_m_swapsentrustDetails',
    description: 'other_v111_swapsentrustDetails',
    keywords: 'other_v111_entrust',
  },
  { url: '/swaps/order', title: '', description: '', keywords: '' },
  {
    url: '/swaps/openContract',
    title: 'other_v111_m_swapsopenContract',
    description: 'other_v111_swapsopenContract',
    keywords: 'other_v111_open_contract',
  },
  { url: '/swaps/introduceContract', title: '', description: '', keywords: '' },
  {
    url: '/swaps/contractInfo',
    title: 'other_v111_m_swapscontractInfo',
    description: 'other_v111_swapscontractInfo',
    keywords: 'other_v111_contractinfo',
  },
  { url: '/swaps/marginRecordDetails', title: '', description: '', keywords: '' },
  { url: '/swaps/swapsSet', title: '', description: '', keywords: '' },
  {
    url: '/swaps/calculator',
    title: 'other_v111_m_swapscalculator',
    description: 'other_v111_swapscalculator',
    keywords: 'other_v111_calculator',
  },
  {
    url: '/swaps/fundsRate',
    title: 'other_v111_m_swapsfundsRate',
    description: 'other_v111_swapsfundsRate',
    keywords: 'other_v111_fundsrate',
  },
  { url: '/swaps/preferences', title: '', description: '', keywords: '' },
  {
    url: '/swaps/invitation',
    title: 'other_v111_m_swapsinvitation',
    description: 'other_v111_swapsinvitation',
    keywords: 'other_v111_invitation',
  },
  { url: '/swaps/invitation/rebateDetail', title: '', description: '', keywords: '' },
  { url: '/swaps/invitation/detail', title: '', description: '', keywords: '' },
  { url: '/swapsSilumation/index', title: '', description: '', keywords: '' },
  {
    url: '/swapsSilumation/exchange',
    title: 'other_v111_m_swapsSilumationexchange',
    description: 'other_v111_swapsSilumationexchange',
    keywords: 'other_v111_simulation',
  },
  { url: '/swapsSilumation/entrustDetails', title: '', description: '', keywords: '' },
  { url: '/swapsSilumation/order', title: '', description: '', keywords: '' },
  { url: '/swapsSilumation/introduceContract', title: '', description: '', keywords: '' },
  {
    url: '/swapsSilumation/contractInfo',
    title: 'other_v111_m_swapsSilumationcontractInfo',
    description: 'other_v111_swapsSilumationcontractInfo',
    keywords: 'other_v111_simulationcontract',
  },
  { url: '/swapsSilumation/marginRecordDetails', title: '', description: '', keywords: '' },
  { url: '/swapsSilumation/swapsSet', title: '', description: '', keywords: '' },
  {
    url: '/swapsSilumation/calculator',
    title: 'other_v111_m_swapsSilumationcalculator',
    description: 'other_v111_swapsSilumationcalculator',
    keywords: 'other_v111_simulationcalculator',
  },
  {
    url: '/swapsSilumation/fundsRate',
    title: 'other_v111_m_swapsSilumationfundsRate',
    description: 'other_v111_swapsSilumationfundsRate',
    keywords: 'other_v111_suimulationfundsrate',
  },
  {
    url: '/swapsSilumation/preferences',
    title: 'other_v111_m_swapsSilumationpreferences',
    description: 'other_v111_swapsSilumationpreferences',
    keywords: 'other_v111_simulationpreference',
  },
  { url: '/swapsSilumation/account', title: '', description: '', keywords: '' },
  {
    url: '/swapsSilumation/financeLog',
    title: 'other_v111_SwapsSimulationFinanceLog',
    description: 'other_v111_swapsSilumationfinanceLog',
    keywords: 'other_v111_simulationfinancelog',
  },
  {
    url: '/swapsSilumation/swapsDetail',
    title: 'other_v111_SwapsSimulationSwapsDetail',
    description: 'other_v111_swapsSilumationswapsDetail',
    keywords: 'other_v111_simulationswapsdetail',
  },
  {
    url: '/swapsSilumation/openContract',
    title: 'other_v111_SwapsSimulationOpenContract',
    description: 'other_v111_swapsSilumationopenContract',
    keywords: 'other_v111_simulationopencontract',
  },
  {
    url: '/lever/index',
    title: 'other_v111_leverindexcryptotrading',
    description: 'other_v111_leverindex',
    keywords: 'other_v111_lever',
  },
  {
    url: '/lever/exchange',
    title: 'other_v111_LeverExchangeCryptocurrencyExchange',
    description: 'other_v111_leverexchange',
    keywords: 'other_v111_lever_exchange',
  },
  {
    url: '/lever/OpenLever',
    title: 'other_v111_openlevercryptotrading',
    description: 'other_v111_leverOpenLever',
    keywords: 'other_v111_open_lever',
  },
  {
    url: '/lever/details',
    title: 'other_v111_leverdetailscryptotrading',
    description: 'other_v111_leverdetails',
    keywords: 'other_v111_lever_details',
  },
  { url: '/lever/entrustOrder', title: '', description: '', keywords: '' },
  {
    url: '/c2c/index',
    title: 'other_v111_C2CIndexCryptoTrading',
    description: 'other_v111_c2cindex',
    keywords: 'other_v111_c2c',
  },
  { url: '/c2c/order/index', title: '', description: '', keywords: '' },
  { url: '/c2c/advertising', title: '', description: '', keywords: '' },
  { url: '/c2c/advertising/myAdvertising', title: '', description: '', keywords: '' },
  {
    url: '/c2c/details',
    title: 'other_v111_C2CTradingDetails',
    description: 'other_v111_c2cdetails',
    keywords: 'other_v111_C2CTrading',
  },
  {
    url: '/c2c/paymentTerm',
    title: 'other_v111_C2CPaymentTermcryptocurrencytrading',
    description: 'other_v111_c2cpaymentTerm',
    keywords: 'other_v111_c2cpayment',
  },
  {
    url: '/c2c/allPaymentTerm',
    title: 'other_v111_C2CAllPaymentTermcryptocurrency',
    description: 'other_v111_c2callPaymentTerm',
    keywords: 'other_v111_allpaymentterm',
  },
  {
    url: '/c2c/addPaymentTerm',
    title: 'other_v111_C2CAddPaymentTermCryptocurrency',
    description: 'other_v111_c2caddPaymentTerm',
    keywords: 'other_v111_addpaymentterm',
  },
  {
    url: '/c2c/trade/creditCard',
    title: 'other_v111_C2CTradeCreditCardCryptocurrency',
    description: 'other_v111_c2ctradecreditCard',
    keywords: 'other_v111_c2ctradewithcreditcard',
  },
  {
    url: '/c2c/trade/CreditCardOrder',
    title: 'other_v111_C2CTradeCreditCardOrderCryptocurrency',
    description: 'other_v111_c2ctradeCreditCardOrder',
    keywords: 'other_v111_tradecreditcard',
  },
  { url: '/c2c/trade/simplex', title: '', description: '', keywords: '' },
  {
    url: '/c2c/trade/coinify',
    title: 'other_v111_m_C2CTradeCoinify',
    description: 'other_v111_c2ctradecoinify',
    keywords: 'other_v111_coinify',
  },
  {
    url: '/c2c/trade/pexpay',
    title: 'other_v111_m_C2CTradePexpay',
    description: 'other_v111_c2ctradepexpay',
    keywords: 'other_v111_pexpay',
  },
  {
    url: '/c2c/trade/alchemypay',
    title: 'other_v111_m_C2CTradeAlchemyPay',
    description: 'other_v111_c2ctradealchemypay',
    keywords: 'other_v111_alchemy',
  },
  {
    url: '/c2c/trade/goAppOrder/success',
    title: 'other_v111_m_C2CTradeGoAppOrderSucess',
    description: 'other_v111_c2ctradegoAppOrdersuccess',
    keywords: 'other_v111_ordersuccess',
  },
  {
    url: '/c2c/trade/goAppOrder/failed',
    title: 'other_v111_m_C2CTradeGoAppOrderFailed',
    description: 'other_v111_c2ctradegoAppOrderfailed',
    keywords: 'other_v111_orderfailed',
  },
  {
    url: '/wealthManagement/index',
    title: 'other_v111_m_WealthManagementIndex',
    description: 'other_v111_wealthManagementindex',
    keywords: 'other_v111_wealth_management',
  },
  { url: '/wealthManagement/productList', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/subscribeCurrent', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/subscribeFixed', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/currentTreasure', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/TimeTreasure', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/OpenTransfer', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/CurrentTreasureDetail', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/TimeTreasureDetail', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/CurrentTreasureBack', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/Redeem', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/trial/subscribeFixed', title: '', description: '', keywords: '' },
  { url: '/wealthManagement/trial/TimeTreasure', title: '', description: '', keywords: '' },
  { url: '/nft', title: 'other_v111_m_NFTHotcoin', description: 'other_v111_nft', keywords: 'other_v111_nft_' },
  {
    url: '/nft/home',
    title: 'other_v111_m_NFThome',
    description: 'other_v111_nfthome',
    keywords: 'other_v111_NFT_home',
  },
  {
    url: '/nft/game/detail',
    title: 'other_v111_m_NFTGameDetail',
    description: 'other_v111_nftgamedetail',
    keywords: 'other_v111_nftgame',
  },
  {
    url: '/nft/games',
    title: 'other_v111_NFTGamesHotcoin',
    description: 'other_v111_nftgames',
    keywords: 'other_v111_nftgames',
  },
  {
    url: '/nft/videos',
    title: 'other_v111_nftvideosmt',
    description: 'other_v111_nftvideos',
    keywords: 'other_v111_nftvideosmk',
  },
  { url: '/nft/igo', title: 'other_v111_nftigomt', description: 'other_v111_nftigo', keywords: 'other_v111_nftigomk' },
  {
    url: '/nft/igo/token/detail',
    title: 'other_v111_nftigotokendetailmt',
    description: 'other_v111_nftigotokendetail',
    keywords: 'other_v111_nftigotokendetailmk',
  },
  {
    url: '/nft/igo/mysterybox/detail',
    title: 'other_v111_nftigomysteryboxdetailmt',
    description: 'other_v111_nftigomysteryboxdetail',
    keywords: 'other_v111_nftigomysteryboxdetailmk',
  },
  {
    url: '/nft/market',
    title: 'other_v111_nftmarketmt',
    description: 'other_v111_nftmarket',
    keywords: 'other_v111_nftmarketmk',
  },
  {
    url: '/nft/market/allProject',
    title: 'other_v111_nftmarketallProjectmt',
    description: 'other_v111_nftmarketallProject',
    keywords: 'other_v111_nftmarketallProjectmk',
  },
  {
    url: '/nft/market/projectDetails',
    title: 'other_v111_nftmarketprojectDetailsmt',
    description: 'other_v111_nftmarketprojectDetails',
    keywords: 'other_v111_nftmarketprojectDetailsmk',
  },
  {
    url: '/nft/market/nftDetails',
    title: 'other_v111_nftmarketnftDetailsmt',
    description: 'other_v111_nftmarketnftDetails',
    keywords: 'other_v111_nftmarketnftDetailsmk',
  },
  {
    url: '/nft/asset',
    title: 'other_v111_nftassetmt',
    description: 'other_v111_nftasset',
    keywords: 'other_v111_nftassetmk',
  },
  {
    url: '/nft/asset/regularNft',
    title: 'other_v111_nftassetegularNftmt',
    description: 'other_v111_nftassetregularNft',
    keywords: 'other_v111_nftassetregularNftmk',
  },
  {
    url: '/nft/asset/mysteryBoxes',
    title: 'other_v111_nftassetmysteryBoxesmt',
    description: 'other_v111_nftassetmysteryBoxes',
    keywords: 'other_v111_nftassetmysteryBoxesmt',
  },
  { url: '/nft/asset/favorites', title: '', description: '', keywords: '' },
  { url: '/nft/asset/orders', title: '', description: '', keywords: '' },
  { url: '/nft/asset/deposit', title: '', description: '', keywords: '' },
  { url: '/nft/asset/deposit/contractAddress', title: '', description: '', keywords: '' },
  { url: '/nft/asset/withdraw/withdrawBefore', title: '', description: '', keywords: '' },
  { url: '/nft/asset/withdraw', title: '', description: '', keywords: '' },
  { url: '/nft/asset/withdraw/addAddress', title: '', description: '', keywords: '' },
  { url: '/nft/asset/detail', title: '', description: '', keywords: '' },
  { url: '/nft/asset/onsale', title: '', description: '', keywords: '' },
  {
    url: '/ieo/detail',
    title: 'other_v111_ieodetailmt',
    description: 'other_v111_ieodetail',
    keywords: 'other_v111_ieodetailmk',
  },
  { url: '/ieo/order', title: '', description: '', keywords: '' },
  {
    url: '/activity/fifthAnniversary',
    title: 'other_v111_activityfifthAnniversarymt',
    description: 'other_v111_activityfifthAnniversary',
    keywords: 'other_v111_activityfifthAnniversarymk',
  },
  {
    url: '/activity/fifthAnniversary/detail',
    title: 'other_v111_activityfifthAnniversarydetailmt',
    description: 'other_v111_activityfifthAnniversarydetail',
    keywords: 'other_v111_activityfifthAnniversarydetailmk',
  },
  {
    url: '/activity/swapTrade/index',
    title: 'other_v111_activityswapTradeindexmt',
    description: 'other_v111_activityswapTradeindex',
    keywords: 'other_v111_activityswapTradeindexmk',
  },
  {
    url: '/activity/kol-incentive-plan',
    title: 'other_v111_activitykolincentiveplanmt',
    description: 'other_v111_activitykolincentiveplan',
    keywords: 'other_v111_activitykolincentiveplanmk',
  },
  { url: '/pay/index', title: '', description: '', keywords: '' },
  { url: '/pay/transfer/account', title: '', description: '', keywords: '' },
  { url: '/pay/transfer/amount', title: '', description: '', keywords: '' },
  { url: '/pay/transfer/success', title: '', description: '', keywords: '' },
  { url: '/pay/transfer/detail', title: '', description: '', keywords: '' },
  { url: '/pay/record', title: '', description: '', keywords: '' },
  { url: '/pay/collect/index', title: '', description: '', keywords: '' },
  { url: '/pay/collect/setcoin', title: '', description: '', keywords: '' },
  { url: '/pay/collect/detail', title: '', description: '', keywords: '' },
  { url: '/pay/setting/index', title: '', description: '', keywords: '' },
  { url: '/pay/setting/limit', title: '', description: '', keywords: '' },
  {
    url: '/chargeBack',
    responsive: true,
    title: 'other_v111_chargeBackmt',
    description: 'other_v111_chargeBack',
    keywords: 'other_v111_chargeBackmk',
  },
  { url: '/chargeBack/search', title: '', description: '', keywords: '' },
  { url: '/chargeBack/applyFor', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderBearer/myBearer', title: '', description: '', keywords: '' },
  {
    url: '/chargeBack/orderBearer/homepage',
    title: 'other_v111_chargeBackorderBearerhomepagemt',
    description: 'other_v111_chargeBackOrderBearerhomepage',
    keywords: 'other_v111_chargeBackorderBearerhomepagemk',
  },
  { url: '/chargeBack/orderBearer/bearerSet', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderBearer/shareDetailsTreat', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderBearer/shareDetailsHistory', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderBearer/followUpSettings', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderDocumentary/myDocumentary', title: '', description: '', keywords: '' },
  {
    url: '/chargeBack/orderDocumentary/documentarySet',
    title: '',
    description: 'other_v111_chargeBackorderDocumentarydocumentarySet',
    keywords: '',
  },
  { url: '/chargeBack/orderBearer/tradeLever', title: '', description: '', keywords: '' },
  { url: '/chargeBack/orderBearer/upLever', title: '', description: '', keywords: '' },
  {
    url: '/WealthCoinManagement/index',
    title: 'other_v111_WealthCoinManagementindexmt',
    description: 'other_v111_WealthCoinManagementindex',
    keywords: 'other_v111_WealthCoinManagementindexmk',
  },
  {
    url: '/WealthCoinManagement/qualificationTest',
    title: 'other_v111_WealthCoinManagementqualificationTestmt',
    description: 'other_v111_WealthCoinManagementqualificationTest',
    keywords: 'other_v111_WealthCoinManagementqualificationTestmk',
  },
  { url: '/WealthCoinManagement/subscribe', title: '', description: '', keywords: '' },
  { url: '/WealthCoinManagement/treasureDetail', title: '', description: '', keywords: '' },
  {
    url: '/welfare/center',
    title: 'other_v111_welfarecentermt',
    description: 'other_v111_welfarecenter',
    keywords: 'other_v111_welfarecentermk',
  },
  {
    url: '/welfare/moreTask',
    title: 'other_v111_welfaremoreTaskmt',
    description: 'other_v111_welfaremoreTask',
    keywords: 'other_v111_welfaremoreTaskmk',
  },
  { url: '/welfare/myTaskList', title: '', description: '', keywords: '' },
  { url: '/welfare/myReward', title: '', description: '', keywords: '' },
  { url: '/welfare/taskLog', title: '', description: '', keywords: '' },
  { url: '/welfare/contractTicket', title: '', description: '', keywords: '' },
  {
    url: '/learn/index',
    title: 'other_v111_learnindexmt',
    description: 'other_v111_learnindex',
    keywords: 'other_v111_learnindexmk',
    responsive: true,
  },
  {
    url: '/learn/list',
    title: 'other_v111_learnlistmt',
    description: 'other_v111_learnlist',
    keywords: 'other_v111_learnlistmk',
  },
  {
    url: '/learn/article',
    title: 'other_v111_learnarticlemt',
    description: 'other_v111_learnarticle',
    keywords: 'other_v111_learnarticlemk',
  },
  {
    url: '/vip/service',
    title: 'other_v111_vipservicemt',
    description: 'other_v111_vipservice',
    keywords: 'other_v111_vipservicemk',
  },
  {
    url: '/vip/application',
    title: 'other_v111_vipapplicationmt',
    description: 'other_v111_vipapplication',
    keywords: 'other_v111_vipapplicationmk',
  },
  {
    url: '/rateStandard/index',
    title: 'other_v111_rateStandardindexmt',
    description: 'other_v111_rateStandardindex',
    keywords: 'other_v111_rateStandardindexmk',
  },
  {
    url: '/preMarket/index',
    title: 'other_v111_preMarketindexmt',
    description: 'other_v111_preMarket',
    keywords: 'other_v111_preMarketindexmk',
  },
  {
    url: '/preMarket/detail',
    title: 'other_v111_preMarketdetailmt',
    description: 'other_v111_preMarketdetail',
    keywords: 'other_v111_preMarketdetailmk',
  },
  { url: '/preMarket/myOrders', title: '', description: '', keywords: '' },
  // { url: '/preMarket/myOrders/:orderId/detail', title: '', description: '', keywords: '' },
  { url: '/inMail/noticeList', title: '', description: '', keywords: '' },
  { url: '/inMail/noticeNavList', title: '', description: '', keywords: '' },
  { url: '/r/codeXXX' }, // todo: 待确认方案。
  { url: '/sentry' },
  { url: '/customer' },
  { url: '/personalCenter/accesskey/list' },
  { url: '/personalCenter/accesskey/create' },
]

module.exports = urls
